import {UpperCasePipe} from "@angular/common"
import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {PbrExportSummary, PbrExportQueryResult} from "@app/common/services/material-maps-exporter/material-maps-exporter.service"
import {PbrExport} from "@cm/material-maps-exporter"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-output-pbr-export-detail",
    imports: [UpperCasePipe],
    templateUrl: "./material-output-pbr-export-detail.component.html",
    styleUrl: "./material-output-pbr-export-detail.component.scss",
})
export class MaterialOutputPbrExportDetailComponent {
    readonly $exportSummary = input.required<PbrExportSummary>({alias: "exportSummary"})
    readonly $sourceInfo = input.required<string>({alias: "sourceInfo"})

    mapWorkflows(workflows: PbrExportQueryResult["summary"]["workflow"]) {
        return workflows.map((x) => PbrExport.Utils.workflowToString(x))
    }

    mapEngines(engines: PbrExportQueryResult["summary"]["engine"]) {
        return engines.map((x) => PbrExport.Utils.engineToString(x))
    }

    mapNormalYs(normalY: PbrExportQueryResult["summary"]["normalY"]) {
        return normalY.map((x) => PbrExport.Utils.normalYToString(x))
    }

    mapResolutions(resolutions: PbrExportQueryResult["summary"]["resolution"]) {
        return resolutions.map((x) => PbrExport.Utils.resolutionToString(x))
    }
}
